
import * as React from "react";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { DashboardSidebar } from "./DashboardSidebar";
import { DashboardHeader } from "./DashboardHeader";
import { usePageInfo } from "@/hooks/usePageInfo";
import { useAuth } from "@/hooks/useAuth.tsx";
import { AnimatedLogo } from "@/components/AnimatedLogo.tsx";

export function DashboardLayout({ children, ...props }: React.ComponentProps<typeof SidebarProvider>) {
  const {user, isLoading} = useAuth();
  const pageInfo = usePageInfo();

  if(isLoading) return (
      <div className="h-screen w-full flex items-center justify-center">
        <AnimatedLogo />
      </div>
  )

  return (
    <>
      <SidebarProvider>
        <DashboardSidebar
          user={user}
        />
        <SidebarInset>
          <DashboardHeader pageInfo={pageInfo} />
          {/* Main content */}
          <div className="flex flex-1 flex-col gap-4 p-4">
            <div className="w-full text-foreground p-6 border border-border rounded-md bg-background">
              {children}
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </>
  );
}
